import React, { useEffect } from 'react'
import Hero from '../components/approachMain/Hero'
import Approaches from '../components/approachMain/Approaches'
import OurServices from '../components/approachMain/OurServices'
import TestimonialBody from '../components/approachMain/TestimonialBody'


const ApproachMain = () => {

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  return (
    <div className='h-fit w-[100vw] lg:w-full overflow-x-hidden'>
      
      <Hero />

      <Approaches />

      <OurServices />

      {/* <TestimonialBody /> */}
      
    </div>
  )
}

export default ApproachMain
